import React, { useState } from "react";
import { api } from "@/lib/api";
import { StatusBadge, AuthImage, usePoll, fmtUSDT } from "@/components/common";

export default function Deposits() {
  const [deposits, setDeposits] = useState([]);
  usePoll(() => api.get("/customer/deposits").then((r) => setDeposits(r.data)).catch(() => {}), 7000, []);

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Deposits</h1>
      {deposits.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400">No deposits submitted yet.</div>
      ) : (
        <div className="space-y-3" data-testid="deposits-list">
          {deposits.map((d) => (
            <div key={d.id} className="bg-white border border-slate-200 rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
              <div className="flex items-center gap-4">
                {d.file_id && <AuthImage fileId={d.file_id} className="w-16 h-16 rounded-lg object-cover border border-slate-200" />}
                <div>
                  <div className="font-mono text-sm text-slate-900">{d.deposit_ref}</div>
                  <div className="text-sm text-slate-600 mt-0.5">{fmtUSDT(d.amount)} USDT · {d.network}</div>
                  <div className="font-mono text-xs text-slate-400 mt-0.5 break-all max-w-md">TXID: {d.txid}</div>
                  {d.status === "rejected" && d.review_reason && <div className="text-xs text-rose-600 mt-1">Reason: {d.review_reason}</div>}
                </div>
              </div>
              <div className="text-right">
                <StatusBadge status={d.status} />
                {d.verified_amount && <div className="text-xs text-emerald-600 mt-1 font-mono">Credited {fmtUSDT(d.verified_amount)}</div>}
                <div className="text-xs text-slate-400 mt-1">{new Date(d.created_at).toLocaleString()}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
